/* eslint-disable no-useless-constructor,react/destructuring-assignment */
// Copyright (c) 2016 Deere & Company

import './dealer-settings.scss';
import React, { Component } from 'react';
import BusyCounterLoadingIndicator from '../../../../sharedmodules/components/busyCounter/busy-counter-loading-indicator';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import UserDealerInputField from './user-delear-input-fields';
import UserDealerMapping from './user-dealer-mappings';
import { createUserDealerRequest } from '../../services/users-settings-helper';

class DealerSettings extends Component {

    constructor(props) {

        super(props);

    }

    componentWillMount() {

        const { resetUserDealerData } = this.props;
        resetUserDealerData();

    }

    handleExecute = (userDetails, props) => {

        const userDealerRequest = createUserDealerRequest(userDetails);
        props.getUserDealerData(props.auth.getAccessToken, userDealerRequest);

    };

    render() {

        const { busyCounter, userDealerMappedData } = this.props;

        return (
            <section className="dealer-settings">
                <section className="dealer-settings-panel">
                    <BusyCounterLoadingIndicator busyCounter={busyCounter} />
                    <div className="dealer-settings-header">
                        <h5>
                            <FormattedMessage id="USERS_INFORMATION" />
                        </h5>
                    </div>
                    <UserDealerInputField
                        handleExecute={
                            (userDetails) => this.handleExecute(userDetails, this.props)}
                        handleReset={() => this.props.resetUserDealerData()}
                    />
                </section>
                <UserDealerMapping userDealerMappedData={userDealerMappedData} />
            </section>
        );

    }

}

DealerSettings.displayName = 'DealerSettings';
DealerSettings.propTypes = {
    auth: PropTypes.object.isRequired,
    userDealerMappedData: PropTypes.object,
    getUserDealerData: PropTypes.func.isRequired,
    resetUserDealerData: PropTypes.func.isRequired,
    busyCounter: PropTypes.bool.isRequired,
};

export default DealerSettings;
